








































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { POSProduct, POSProductType } from '@pos/interfaces/pos-v2';
import BpcInput from '@shared/components/forms/inputs/input/input.vue';

@Component({
  name: 'pos-change-badge-product-modal',
  components: {
    BpcInput,
  },
})
export default class PosChangeBadgeProductModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({ type: Boolean, default: false }) readonly confirmDisabled: boolean;
  @Prop({ type: Number }) readonly ticketId: number;
  @Prop({ type: Number }) readonly contactId: number;
  @Prop({ type: Number, required: true }) readonly posSessionId!: number;
  @Prop({ type: Object }) readonly product: POSProduct;
  @Prop({ type: String }) readonly productType: POSProductType;
  // DATA
  badgeNumber: string = '';
  saving: boolean = false;
  // COMPUTED

  // METHODS

  closeModal() {
    this.$emit('close');
    this.badgeNumber = '';
  }

  async onConfirm() {
    this.saving = true;
    try {
      const newTicketDetail = await this.$posService.changeBadgeForProduct(
        this.posSessionId,
        this.ticketId,
        this.productType,
        this.product.id,
        this.contactId,
        this.badgeNumber,
        'rfid',
      );
      this.$emit('badge-updated', newTicketDetail);
      this.closeModal();
      this.saving = false;
      this.badgeNumber = '';
    } catch (error) {
      const message = error?.response?.data?.message;
      this.$bpcMessage.showErrorMessage({ text: message ? message : error });
      console.error(error);
      this.saving = false;
      this.badgeNumber = '';
    }
  }

  // LIFECYCLE HOOKS
  // mounted() {}

  // WATCHERS
}
